import Create from './create/CreateTrack';
import Edit from './edit/EditTrack';
import Individual from './individual/Track';
import List from './list/Tracks';

export default { Individual, List, Create, Edit };
